/**
 * 正则校验
 * */
export var verify = {
  pattern_idcard15: '^[1-9]\\d{7}((0\\d)|(1[0-2]))(([0|1|2]\\d)|3[0-1])\\d{3}$',
  pattern_idcard18: '^[1-9]\\d{5}[1-9]\\d{3}((0\\d)|(1[0-2]))(([0|1|2]\\d)|3[0-1])\\d{3}([0-9]|X)$',
  pattern_workPhone: '(^\\d{3}-\\d{8}$)|(^\\d{4}-\\d{7}$)',
  pattern_mobilePhone: '^(13[0-9]|14[5-9]|15[0|1|2|3|5|6|7|8|9]|166|17[3|5|6|7|8]|18[0-9]|19[1|8|9])\\d{8}$',
  pattern_fax: '^(?:\\d{3,4}-)?\\d{7,8}(?:-\\d{1,6})?$',
  pattern_email: '^\\w+([-+.]\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$',
  pattern_postalCode: '[1-9]\\d{5}(?!\\d)',
  pattern_Chinese: '^[\\u4E00-\\u9FA5]+$'
}
